(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('authorizeHttpInterceptor', authorizeHttpInterceptor);

    authorizeHttpInterceptor.$inject = ['$q', '$injector', 'user', 'headerNames', 'statusCodes', 'urls', 'authenticationSchemes', 'reasonPhrases'];
    function authorizeHttpInterceptor($q, $injector, user, headerNames, statusCodes, urls, authenticationSchemes, reasonPhrases) {
        return {
            request: request,
            responseError: responseError
        };

        function request(config) {
            var signInManager = getSignInManager(),
                gettextCatalog = getCatalog(),
                isTokenRequest = config.url === urls.openIdToken,
                isLanguageRequest = config.cache === gettextCatalog.cache;

            config.headers[headerNames.requestWith] = 'XMLHttpRequest';
            return !isTokenRequest && !isLanguageRequest ? signInManager.isSignedIn().then(checkRoles).then(success, error) : config;

            function checkRoles(token) {
                return !config.requireAdmin || user.isAdmin ? token : $q.reject();
            }

            function success(token) {
                config.headers[headerNames.authorization] = authenticationSchemes.bearer + ' ' + token.access_token;
                return config;
            }

            function error(rejection) {
                if (config.allowAnonymous)
                    return config;

                return $q.reject({
                    config: config,
                    status: statusCodes.unauthorized,
                    statusText: reasonPhrases[statusCodes.unauthorized]
                });
            }
        }

        function responseError(rejection) {
            var signInManager;
            if (rejection && rejection.status == statusCodes.unauthorized) {
                $injector.get('signInManager').signOut();
            }

            return $q.reject(rejection);
        }

        function getSignInManager() {
            return getSignInManager.$value || (getSignInManager.$value = $injector.get('signInManager'));
        }
        function getCatalog() {
            return getCatalog.$value || (getCatalog.$value = $injector.get('gettextCatalog'));
        }
    }
})();